import styled, { css } from 'styled-components';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';

import { colors } from 'global/colors';

export const HeaderComponent = styled.div``;

export const FullScreenModal = styled(Modal)`
  font-family: 'Open Sans', sans-serif;
  width: 100vw;
  max-width: none !important;
  height: 100vh;
  margin: 0 !important;
  animation: blowUpModal 1s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
  @keyframes blowUpModal {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
  .modal-content {
    height: 100vh;
    border: 0;
    border-radius: 0;
  }
  p {
    font-size: 15px;
  }
`;

export const FullScreenHeaderContainer = styled.div`
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
  padding: 1rem 1rem;
`;

export const FullScreenModalTitle = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  align-items: center;
  justify-items: center;
  color: ${colors.fsDarkBlue};
  font-size: 19px;
  font-weight: 500;
  letter-spacing: 0.7px;
  gap: 10px;
  .left {
    justify-self: left;
  }
  .right {
    justify-self: right;
  }
  @media (max-width: 768px) {
    grid-template-rows: 1fr 1fr 1fr;
    grid-template-columns: none;
    .left {
      justify-self: center;
    }
    .right {
      justify-self: center;
    }
  }
`;

export const FullScreenModalBody = styled(ModalBody)`
  display: flex;
  justify-content: center;
  overflow-x: auto;
  width: 100%;
  padding: 0;
`;

export const LevelDataContainer = styled.div`
  width: 600px;
  padding: 0 40px;
  @media (max-width: 768px) {
    padding: 0 40px;
    width: 100%;
  }
`;

export const TextContainer = styled.div``;

export const FlowText = styled.div``;

export const FullScreenFooterContainer = styled(ModalFooter)`
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 5px;
`;

export const FullScreenModalFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: 5px;
`;

export const LanguageContainer = styled.div`
  color: ${colors.fsDarkBlue};
`;

export const CardContainer = styled.div`
  display: grid;
  height: auto;
  min-height: 200px;
`;

export const Card = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  transition: transform 0.5s;
  transform-style: preserve-3d;

  ${({ isFlipped }) =>
    isFlipped &&
    `
    transform: rotateY(180deg);
  `}
`;

export const CardFront = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: rgba(0, 0, 0, 1) 0px 0px 10px;
  padding: 20px;
`;

export const CardBack = styled.div`
  width: 100%;
  height: 100%;
  transform: rotateY(180deg);
  display: flex;
  flex-direction: column;
  box-shadow: rgba(0, 0, 0, 1) 0px 0px 10px;
  padding: 20px;
`;

export const Label = styled.label`
  font-size: 14px;
  color: ${colors.darkGray};
  margin: 0;
  font-weight: 600;
  display: flex;
  align-items: center;
  user-select: none;
  margin-bottom: 15px;
`;

export const OptionContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10px;

  :hover {
    background-color: whitesmoke;
  }

  ${({ markedOption }) =>
    markedOption &&
    `
      background: whitesmoke;
    `}
  ${({ submitted }) =>
    submitted &&
    `
      cursor: default;
    `}
`;

export const Option = styled.div`
  font-size: 14px;
  color: ${colors.darkGray};

  img {
    max-width: 150px;
  }
`;

export const Icon = styled.i.attrs(({ icon }) => ({ className: icon }))`
  margin-right: 10px;
  font-size: 20px;
  color: ${colors.fsDarkBlue};

  ${({ isCorrectIncorrect }) =>
    isCorrectIncorrect &&
    `
    font-size: 14px;
    margin-right: 6px;
    color: ${colors.darkGray};
    `}
`;

export const StatusLabel = styled.div`
  font-size: 14px;
  color: ${colors.darkGray};
  font-weight: 600;
  padding-top: 15px;
  padding-bottom: 10px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
  }
`;

export const HintAndExplanationButtonContainer = styled.div`
  display: flex;
`;

export const ExplanationHeadingContainer = styled.label`
  color: ${colors.darkGray};
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 14px;
`;

export const ExplanationContainer = styled.label`
  color: ${colors.darkGray};
  font-size: 14px;
  margin-bottom: 0;
`;

export const InteractContainer = styled.div`
  box-shadow: rgb(0, 0, 0) 0px 0px 10px;
  padding: 10px;
  margin-bottom: 10px;
  overflow: hidden;
  max-height: 400px;
  background: ${({ theme }) => theme.pageBackground};
`;

export const StepProgressBarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 600px;
  @media (max-width: 768px) {
    max-width: 70vw;
  }
`;

export const StepsContainer = styled.div`
  display: flex;
  gap: 6px;
  width: 100%;
  @media (max-width: 768px) {
    width: none;
  }
`;

export const StepContainer = styled.div`
  border-radius: 6px;
  overflow: hidden;
  height: 10px;
  width: 100%;
  @media (max-width: 768px) {
    width: none;
  }
`;

export const Step = styled.progress`
  height: 22px;
  max-width: 100%;
  appearance: none;
  background-color: ${colors.gray};
  margin: 0;
  cursor: pointer;
  border-radius: 6px;
  box-shadow: 2px 1px 2px 1px ${colors.gray};
  &::-webkit-progress-value {
    background-color: ${(props) => (props.isActive ? colors.fsCyan : colors.fsDarkBlue)};
    transition: width 0.5s ease-in-out;
  }
  &::-webkit-progress-bar {
    background-color: ${colors.gray};
  }
  &::-moz-progress-bar {
    background-color: ${(props) => (props.isActive ? colors.fsCyan : colors.fsDarkBlue)};
  }
`;

export const ArrowIcon = styled.i.attrs(({ icon }) => ({ className: icon }))`
  font-size: 20px;
  cursor: pointer;
  padding: 10px;
  margin: 0 10px;
  :hover {
    background: ${colors.lightGray};
    border-radius: 10px;
  }
  ${(props) =>
    props.disabled &&
    css`
      color: ${colors.gray};
    `}
`;
